import { FC, ReactNode } from "react";
import { createPortal } from "react-dom";

interface BaseModalProps {
    title?: ReactNode;
    children?: ReactNode;
    close?: () => void;
    fullWidth?: boolean;
    fullHeight?: boolean;
    actions?: ReactNode;
    footer?: ReactNode | (() => ReactNode);
    open?: boolean;
    className?: string;
}
const BaseModal: FC<BaseModalProps> = ({
    title,
    children,
    close,
    fullWidth,
    fullHeight,
    footer,
    actions,
    open,
    className
}) => {
    if (!open) {
        return null;
    }
    return createPortal(
        <div className={`fixed inset-0 bg-black/40 flex items-center justify-center z-[2147483647]`}>
            <div className={`bg-white rounded-lg p-5 min-w-[300px] 
                ${fullWidth ? 'w-[calc(100%-40px)]' : ''}
                ${fullHeight ? 'h-[calc(100%-40px)]' : ''}
                flex flex-col max-w-[calc(100%-40px)] max-h-[calc(100%-40px)]
                ${className || ""}
                `}>

                <div className="flex justify-between mb-2">
                    <div className="font-semibold">{title}</div>
                    <button onClick={close}>✕</button>
                </div>

                <div className="flex-1 overflow-y-auto">
                    {children}
                </div>
                {/* {children} */}

                {footer && <div className="mt-2">{typeof footer === "function" ? footer() : footer}</div>}
                {actions && <div className="flex justify-end gap-2 mt-2">{actions}</div>}
            </div>
        </div>,
        document.body
    );
}

export default BaseModal;